import { classNames } from 'primereact/utils';
import { FormEvent, useEffect, useState } from 'react';
import { useCreateOrUpdateTicketMutation, useGetTicketMutation, useGetTicketNachrichtenMutation, useNewTicketNachrichtMutation } from '../../../api/TicketAPI';
import { ITicket, ITicketNachrichtenResponseDto } from '../../../types/Types';
import { formatToEuroDateTime } from '../../../util/DateUtils';
import styles from './ticketCard.module.scss';
import MaxInputAnzahlComponent from '../../../component/MaxInputAnzahlComponent';

export type TicketCardProps = {
    uid: string,
    refresh: () => void
    close: () => void
}

const emptyTicket: ITicket = {
    uid: '',
    kurzbeschreibung: '',
    langbeschreibung: '',
    reporter: '',
    status: '',
    erstelltAm: new Date(),
    prio: '',
    nummer: 0,
}

const TicketCard = (props: TicketCardProps) => {

    //const navigate = useNavigate();
    const [getTicketAPI] = useGetTicketMutation();
    const [updateTicketAPI] = useCreateOrUpdateTicketMutation();
    const [getTicketNachrichtenAPI] = useGetTicketNachrichtenMutation();
    const [writeTicketNachrichtAPI] = useNewTicketNachrichtMutation();

    const [ticket, setTicket] = useState<ITicket>(emptyTicket);
    const [ticketresponse, setTicketresponse] = useState<string>((""));
    const [nachrichtenListe, setNachrichtenListe] = useState<ITicketNachrichtenResponseDto[]>([]);

    const saveTicketResponse = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        writeTicketNachrichtAPI({
            uid: props.uid,
            text: ticketresponse
        }).unwrap().then(() => {
            setTicketresponse("");
            ladeNachrichten();
        }).catch((e) => alert("" + e))
            ;
    }

    const handlePrioChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if (!ticket) return;

        setTicket((prevData) => ({
            ...prevData,
            prio: e.target.value
        }));

        updateTicketAPI({
            uid: ticket.uid,
            kurzbeschreibung: ticket.kurzbeschreibung,
            langbeschreibung: ticket.langbeschreibung,
            reporter: ticket.reporter,
            status: ticket.status,
            prio: e.target.value
        })
            .unwrap()
            .then(() => {
                props.refresh();
            })
            .catch((e) => {
                ladeTicket();
                console.log(e);
            });
    }

    const submit = async (status: string) => {

        if (!ticket) return;

        updateTicketAPI({
            uid: ticket.uid,
            kurzbeschreibung: ticket.kurzbeschreibung,
            langbeschreibung: ticket.langbeschreibung,
            reporter: ticket.reporter,
            status: status,
            prio: ticket.prio
        })
            .then(() => {
                props.refresh();
                props.close();
            })
            .catch((e) => alert("" + e));
    }

    const ladeTicket = () => {
        getTicketAPI(props.uid).unwrap()
            .then((data) => setTicket(data))
    }

    const ladeNachrichten = () => {
        getTicketNachrichtenAPI(props.uid)
            .unwrap()
            .then(setNachrichtenListe)
            .catch((e) => console.log(e));
    }

    useEffect(() => {
        ladeNachrichten();
    }, [ticket]);

    useEffect(() => {
        ladeTicket();
    }, [props.uid]);

    return (
        <>
            {!ticket ?
                <div>Lade Ticket...</div>
                :
                <>
                    <div className={classNames(styles.auftragCard)}>
                        <div style={{ padding: '10px' }}>

                            <div style={{ display: 'flex', justifyContent: 'end' }}>
                                <i className="bi bi-x-lg" style={{ fontSize: '1.5em', cursor: 'pointer' }} onClick={() => props.close()}></i>
                            </div>

                            <div>
                                <h4 className={classNames(styles.advertisementCardHeader)}>TICKET {ticket.nummer}: <span style={{ fontWeight: "bold", overflowWrap: "anywhere",  wordBreak: "break-word"}}>{ticket.kurzbeschreibung}</span></h4>
                            </div>

                            <div className="card">
                                <div className="card-header">
                                    <div>Erstellt am: {formatToEuroDateTime(ticket.erstelltAm)}</div>
                                    <div>Reporter: {ticket.reporter}</div>
                                    <div>Status: {ticket.status}</div>
                                    <div>Prio: <select value={ticket.prio} onChange={handlePrioChanged}>
                                        <option value="KRITISCH">KRITISCH</option>
                                        <option value="NIEDRIG">NIEDRIG</option>
                                        <option value="MITTEL">MITTEL</option>
                                        <option value="HOCH">HOCH</option>
                                    </select>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {ticket.langbeschreibung}
                                </div>
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: "10px", marginTop: "10px" }}>
                                <button className="btn btn-warning" onClick={() => submit("OFFEN")}>offen</button>
                                <button className="btn btn-info" onClick={() => submit("IN_ABSTIMMUNG")}>in abstimmung</button>
                                <button className="btn btn-primary" onClick={() => submit("IN_BEARBEITUNG")}>in bearbeitung</button>
                                <button className="btn btn-light" onClick={() => submit("IN_ABNAHME")}>in abnahme</button>
                                <button className="btn btn-success" onClick={() => submit("FERTIG")}>fertig</button>
                                <button className="btn btn-danger" onClick={() => submit("WONTFIX")}>wontfix</button>
                            </div>

                            <div style={{ marginTop: '20px' }}>
                                Nachrichten {nachrichtenListe.length}

                                {nachrichtenListe.map((nachricht, index) => (
                                    <>
                                        <div key={index} className="card" style={{ marginTop: '10px' }}>

                                            <div className="card-header">
                                                <div>Nachricht von: {nachricht.erstelltVonEmail} am {formatToEuroDateTime(nachricht.erstelltAm)}</div>
                                            </div>
                                            <div className="card-body">
                                                <span style={{overflowWrap: "anywhere",  wordBreak: "break-word"}}>{nachricht.text}</span>    
                                            </div>
                                        </div>
                                    </>
                                ))}

                                <div style={{ marginTop: '10px' }}>
                                    <form onSubmit={saveTicketResponse} className='form-horizontal'>
                                        <div className="form-group">
                                            <label htmlFor="ticketresponse">Neue Nachricht:</label>
                                            <textarea className="form-control"
                                                id="ticketresponse"
                                                value={ticketresponse}
                                                rows={3}
                                                maxLength={255}
                                                required={true}
                                                onChange={(e) => setTicketresponse(e.target.value)} >
                                            </textarea>
                                            <MaxInputAnzahlComponent aktuell={ticketresponse.length} max={255} />
                                        </div>
                                        <input type='submit' value='Absenden' className="btn btn-primary" />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </>}
        </>
    );
}

export default TicketCard;

